import React from 'react';

const SUPPORT_EMAIL = 'helloontimecheckin@gmail.com';

const AccountSupportSection = () => {
  return (
    <section
      className="rounded-3xl border-[3px] border-ink/15 bg-white/95 p-6 shadow-[4px_6px_0_rgba(44,44,44,0.08)]"
      aria-labelledby="support-section-heading"
    >
      <h2
        id="support-section-heading"
        className="font-display text-xl font-semibold text-ink"
      >
        Support
      </h2>
      <p className="mt-1 font-sans text-sm leading-relaxed text-ink/65">
        Need a hand? Feature requests, feedback, and technical difficulties are all
        welcome — just email us.
      </p>

      <div className="mt-6 rounded-2xl border-2 border-ink/10 bg-paper/60 px-4 py-5">
        <p className="font-sans text-xs font-semibold uppercase tracking-wide text-ink/50">
          Email
        </p>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="mt-1 inline-block break-all font-sans text-base font-semibold text-ink underline decoration-ink/25 underline-offset-2 transition hover:decoration-ink"
        >
          {SUPPORT_EMAIL}
        </a>
        <p className="mt-3 font-sans text-sm leading-relaxed text-ink/60">
          Tell us what you were trying to do and what happened. The more detail you
          share, the faster we can help.
        </p>
      </div>
    </section>
  );
};

export default AccountSupportSection;
